const initNavigation = () => {
    jQuery(() => {
        const body = document.body;
        const dropdownTriggers = document.querySelectorAll('.dropdown__trig');
        const dropdownMenus = document.querySelectorAll('.dropdown__menu');
        const dropdowns = document.querySelectorAll('.dropdown');
        const menuTriggers = document.querySelectorAll('.menu-trigger');

        /* Main menu */
        for (const menuTrigger of menuTriggers) {
          menuTrigger.addEventListener('click', (e) => {
            e.preventDefault();
            hideDropdowns();
            body.classList.toggle('body--menu-open');
          });
        }

        /* Dropdowns */
        if(!dropdownTriggers || !dropdownMenus) return;

        for (const trigger of dropdownTriggers) {
          const elId = trigger.getAttribute('data-dropdown');
          const dropdown = document.querySelector('#' + elId);
          if (!dropdown) continue;

          trigger.addEventListener('click', (e) => {
            const isNestedDropdown = dropdown.closest('.dropdown__menu--open');
            if ((window.innerWidth > 992) && !isNestedDropdown) {
              const wasOpened = dropdown.classList.contains('dropdown__menu--open');
              const anotherOpened = document.querySelectorAll('.dropdown__menu--open').length && !wasOpened;

              hideDropdowns(true);

              if (!wasOpened) {
                showDropdown(dropdown, trigger, !anotherOpened);
              }

            } else {
              toggleDropdown(dropdown, trigger);
            }
          });

        }

        body.addEventListener('click', (e) => {
          if (!e.target.closest('.main-nav, .services-nav, .lng-switch')) {
            hideDropdowns(true);
          }

          if (!e.target.closest('.main-nav, .menu-trigger, .lng-switch')) {
            body.classList.remove('body--menu-open');
          }
        });

        const hideDropdowns = (animated = false) => {
          for (const dropdownMenu of dropdownMenus) {
            if(animated) {
              dropdownMenu.classList.add('dropdown__menu--anim');
            } else {
              dropdownMenu.classList.remove('dropdown__menu--anim');
            }
            dropdownMenu.classList.remove('dropdown__menu--open');
          }
          for (const dropdownTrigger of dropdownTriggers) {
            dropdownTrigger.classList.remove('dropdown__trig--active');
          }
          for (const dropdown of dropdowns) {
            dropdown.classList.remove('dropdown--open');
          }
        }

        const showDropdown = (dropdownMenu, trigger, animated = false) => {
          const dropdown = dropdownMenu.closest('.dropdown');
          if(animated) {
            dropdownMenu.classList.add('dropdown__menu--anim');
          } else {
            dropdownMenu.classList.remove('dropdown__menu--anim');
          }

          dropdown?.classList.add('dropdown--open');
          dropdownMenu.classList.add('dropdown__menu--open');
          trigger.classList.add('dropdown__trig--active');
        }

        const toggleDropdown = (dropdownMenu, trigger, animated = false) => {
          const dropdown = dropdownMenu.closest('.dropdown');

          if(animated) {
            dropdownMenu.classList.add('dropdown__menu--anim');
          } else {
            dropdownMenu.classList.remove('dropdown__menu--anim');
          }

          dropdown?.classList.toggle('dropdown--open');
          dropdownMenu.classList.toggle('dropdown__menu--open');
          trigger.classList.toggle('dropdown__trig--active');
        }
    });
}

export { initNavigation };
